export const getIndicatorColor = (indicator) => {
  switch (indicator) {
    case "green":
      return "#78C0B6";
    case "blue":
      return "#409EC3";
    case "yellow":
      return "#FABF38";
    case "red":
      return "#D22F3A";
  }
}

export const getGaugeNormalizedScore = (score) => {
  const finalScore = (score * 100).toFixed(0);
  return Math.max(Math.min(0, finalScore), finalScore);
}